import React                      from 'react';
import PropTypes                  from 'prop-types';
import PriceMatrixComponent       from 'pu-react/components/PriceMatrix';
import PriceMatrixHead            from './PriceMatrixHead';
import CustomPriceMatrixCell      from './CustomPriceMatrixCell';

const PriceMatrix = (props) => {
  if (!props.quote || !props.quote.line_items || !props.quote.line_items.length) {
    return null;
  }

  const lineItem = props.quote.line_items.find((li) => li.product_key === 'assembly-us');
  const { restricted_price } = lineItem

  return (
    <PriceMatrixComponent
      lineItem={lineItem}
      supplier={lineItem.product_key}
      restricted_price={restricted_price}
      parametersChanged={props.parametersChanged}
      prefix_name={`items[${props.itemId}]`}
      rowSelected={props.parameters.row_selected}
      showSummary={props.showSummary}
      groupName="prices"
      matrixHead={PriceMatrixHead}
      matrixCell={CustomPriceMatrixCell}
      {...props} />
  );
};

PriceMatrix.propTypes = {
  quote: PropTypes.objectOf(PropTypes.any).isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  itemId: PropTypes.number.isRequired,
  showSummary: PropTypes.bool.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  parameters: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default PriceMatrix;
